import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Meta from '@bizapp-lp/pjb/organisms/Meta';
import { Complete } from '@bizapp-lp/pjb/templates/Complete';

type CompleteState = {
  valid?: boolean;
};

const title =
  'Project Board 無料トライアルお申し込み完了 | 社内外でのプロジェクトを円滑に進めるためのオンラインシェア型プロジェクト進捗管理サービス';
const description =
  'Project Boardは法人向けオンラインシェア型プロジェクト進捗管理サービスです。プロジェクト管理でよく利用されるガントチャート機能やかんばん機能を搭載し、チームや組織、外部ユーザーとのコラボレーションによる業務の効率化をサポートします。';

const Page: React.FC = () => {
  const { state } = useLocation() as { state: CompleteState };

  return state?.valid ? (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1={'無料トライアルのお申し込み'}
        heading2={'お申し込みが完了しました'}
        description={
          <>
            <span>お申し込みいただき、ありがとうございました。</span>
            <span>確認のためお客様へ自動返信メールをお送りしております。</span>
            <span>準備が整い次第弊社担当よりご連絡いたしますので、</span>
            <span>今しばらくお待ちください。</span>
          </>
        }
      />
    </>
  ) : (
    <Navigate to="/pjb/invalid" replace />
  );
};

const CompleteTrialApplication = React.memo(Page);
export default CompleteTrialApplication;
